module.exports = __webpack_public_path__ + "img/204611b.png";